<template>
    <div id="ticketList">
        <el-card shadow="never">
            <el-row>
                <el-col :span="10">
                    <el-button-group>
                        <el-button type="danger" @click="ticketDelete(tableChecked)" :disabled = 'disabled'  icon="el-icon-delete" ></el-button>
                        <el-button type="info" icon="el-icon-download" @click="exportCode">导出码库</el-button>
                    </el-button-group>
                </el-col>
                <el-col :span="4">
                    <!-- <el-tag type="info">{{tickedName}}</el-tag> -->
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入券码" v-model="input5" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>
            </el-row>
            <el-row class="tiaketListTable">
                <el-col :span="24">
                    <el-table
                        ref="multipleTable"
                        :data="tableData3.filter(data => !input5 || data.voucherId.includes(input5))"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        max-height="500"
                        >
                        <el-table-column
                            type="selection"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            label="券ID"
                            prop="voucherId"
                            width="210">
                        <template slot-scope="scope">{{ scope.row.voucherId }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="typeCode"
                            label="类型编号"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="fromLocation"
                            label="销售地点"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="toLocation"
                            label="使用地点"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="transactionDate"
                            label="使用时间"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="状态"
                            width="120">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <!-- <div class="paging">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="total,prev, pager, next"
                    :total="1000"
                    :current-page.sync="currentPage1"
                    :page-size="9">
                </el-pagination>
            </div> -->
        </el-card>
        
    </div>
</template>
<style lang="less">
    .tiaketListTable{
        margin-top: 20px;
    }
    .paging{
        float: right;
        margin: 20px 0;
    }
</style>
<script>

export default {
    data(){
        return {
            input5:'',
            currentPage1:5,
            //tickedName:'',
            disabled:false,
            activeState:'',
            tableData3:[
                {
                    id:0,
                    voucherId:'A1381555873256082280985',
                    transactionDate:'2019-03-19 13:31',
                    status:'未使用',
                    fromLocation:"上海陆家浜店铺",
                    toLocation:'上海人民广场店铺',
                    typeCode:'0001',
                }
            ],
            multipleSelection: [],
            tableChecked:[],
            ids:[],

        }
    },
    created (){
       
    },
    mounted(){
        this.$nextTick(function(){
            let name = this.$route.params.name ;
            this.tickedName = name ;
            this.disabledCode() ; //禁用按钮
        })


        
    },
    methods:{
        /**
         * @handleSelectionChange(val) 选中的数组
         * @param {array} val 选中的数组
         * @returns {array} 返回选中的数组
         */
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.tableChecked = val;
        },

        // handleSizeChange(val) {
        //     console.log(`每页 ${val} 条`);
        // },

        // handleCurrentChange(val) {
        //     console.log(`当前页: ${val}`);
        // },

        /**
         * @ {fun} ticketDelete() 选择删除
         * @param {array} rows 删除的选项数组
        */
        ticketDelete(rows){
            let that = this;
            // that.tableData3.map((item,index) =>{
            //     return Object.assign(item,{id:index})
            // })
            that.ids = [];
            that.$confirm('确定删除选定？','提示',{
                confirmButtonText:'确定',
                cancelButtonText:'取消',
                type:'warning'
            }).then( () => {
                rows.forEach(element =>{
                    that.ids.push(element.id)
                })
               
                //根据数组id移除数组身上对应的对象
                Array.prototype.remove = function (val) {
                    if( val instanceof Array ){
                        val.forEach((v)=>{
                            this.forEach((value, key)=>{
                                
                                if( v == value.id ){
                                    this.splice(key,1);
                                }
                            })
                            
                        })
                        return
                    }
                    var index = this.indexOf(val);
                    if(index > -1){this.splice(index,1);}
                }
                that.tableData3.remove(that.ids);

            }).catch( () =>{
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });  
            })
        },

        /**
         * @token = '111' 管理员可以更改
         * @token2  其余人员在激活开始的状态下不能修改
         * @fun 删除按钮
        */
        disabledCode(){
            let that = this;
            //先判断是否为管理员，不是 - 进入
            let token = JSON.parse(sessionStorage.getItem('Token'));
            let activeState = that.$route.params.state;
            that.activeState = activeState
            if(token == '111'){
                if(activeState == '进行中' || activeState == '已过期'){
                    that.disabled = true;
                }else if(activeState == '未开始'){
                    that.disabled = false;
                }
                
            }
        },
        /**
         * @getNowFormatDate 当前时间 "2019-03-20"
         * @param 
         */
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },

        /**
         * 下载：导出码库
        */
        exportCode(){
            alert('下载成功')
        }


    },
}
</script>
